import moment from "moment";

/**
 * General Functions
 */
const to12Hr = (time) => moment(time, "HH:mm").format("hh:mma");

const toDatesArray = (startDate, endDate) => {
  let days = [];
  let day = startDate;

  while (day <= endDate) {
    days.push(day.toDate());
    day = day.clone().add(1, "d");
  }

  return days;
};

const changeStartOfWeek = (startDay) => {
  moment.updateLocale('en', {
    week: {
      dow: startDay == 2 ? 6 : startDay == 1 ? 1 : 7, 
      doy: 13,
    }
  });
};

/**
 * Week Functions
 */
const recalculateWeek = (date, startDay) => {
  return date.week();
};
const toWeekInt = (date, startDay) =>
  recalculateWeek(date, startDay);
const toWeekStartDate = (date, startDay) =>
  date.clone().startOf("week");
const toWeekEndDate = (date, startDay) =>
  date.clone().endOf("week");

const toWeekString = (date, startDay) => {
  let startDate = toWeekStartDate(date, startDay);
  let endDate = toWeekEndDate(date, startDay);

  return `${startDate.format("DD")} - ${endDate.format("DD MMMM YYYY")}`;
};

const toWeekArray = (date, startDay) => {
  let startDate = toWeekStartDate(date, startDay);
  let endDate = toWeekEndDate(date, startDay);

  return toDatesArray(startDate, endDate);
};

const toWeekDaysArray = (date, startDay) =>
  toWeekArray(date, startDay).map((day) => moment(day).format("ddd"));
const toWeekDaysArrayFull = (date, startDay) =>
  toWeekArray(date, startDay).map((day) => moment(day));

/**
 * Month Functions
 */
const toMonthInt = (date) => date.format("MM");

const toMonthString = (date) => date.format("MMMM, YYYY");

const toMonthStartDate = (date) => date.startOf("month");
const toMonthEndDate = (date) => date.endOf("month");

const toMonthArray = (date) => {
  let startDate = date.startOf("month");
  let endDate = date.endOf("month");

  return toDatesArray(startDate, endDate);
};

const toMonthCalendarStartDate = (date, startDay) =>
  date.startOf("month").startOf("week");
const toMonthCalendarEndDate = (date, startDay) =>
  date.endOf("month").endOf("week");

const toMonthCalendarArray = (date, startDay) => {
  let startDate = toMonthCalendarStartDate(date, startDay);
  let endDate = toMonthCalendarEndDate(date, startDay);

  return toDatesArray(startDate, endDate);
};

export {
  to12Hr,
  toDatesArray,
  toWeekInt,
  toWeekStartDate,
  toWeekEndDate,
  toWeekString,
  toWeekArray,
  toWeekDaysArray,
  toWeekDaysArrayFull,
  toMonthInt,
  toMonthString,
  toMonthArray,
  toMonthStartDate,
  toMonthEndDate,
  toMonthCalendarStartDate,
  toMonthCalendarEndDate,
  toMonthCalendarArray,
  changeStartOfWeek
};
